<template>
    <div class="temp-content">
        <!--查询筛选-->
        <div class="filter-wrap">
            <div class="filter-item">
                    <div class="filter-title">
                        用户名
                    </div>

                    <div class="filter-element">
                        <t-input
                            placeholder="请输入用户名"
                            maxlength="32"
                            clearable
                        />
                    </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">
                    用户手机
                </div>

                <div class="filter-element">
                    <t-input
                        placeholder="请输入手机号"
                        :maxlength="11"
                        clearable
                    />
                </div>
            </div>

            <div class="filter-item">
                    <div class="filter-title">
                        营地ID
                    </div>

                    <div class="filter-element">
                        <t-input
                            placeholder="请输入营地ID"
                            :maxlength="12"
                            clearable
                            :size="inputSize" 
                        />
                    </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">
                    营地名称
                </div>

                <div class="filter-element">
                    <t-input
                        placeholder="请输入营地名称"
                        :maxlength="60"
                        clearable
                    />
                </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">
                    评分
                </div>

                <div class="filter-element-range">
                    <t-range-input
                        :placeholder="['最低评分', '最高评分']"
                        clearable
                    />
                </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">
                    状态
                </div>

                <div class="filter-element">
                    <t-select
                    :options="statusType"
                    filterable
                    clearable
                    placeholder="请选择"
                    />
                </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">
                    评价时间
                </div>

                <div class="filter-element-time">
                    <t-date-range-picker
                        format="YYYY-MM-DD HH:mm"
                        :enableTimePicker="true"
                        :placeholder="['开始时间', '结束时间']"
                        allowInput
                        clearable
                    />
                </div>
            </div>

            <div class="filter-button">
                <t-button>
                    查询
                </t-button>

                <t-button variant="outline">
                    重置
                </t-button>
            </div>

        </div>

        <!--评价列表-->
        <t-table
            tableLayout="fixed"
            show-header="true"
            cell-empty-content="--"
            row-key="index"
            :data="rateData" 
            :columns="columns"
            :pagination="pagination"
            resizable
            lazy-load
            size="large"
            @row-click="handleRowClick"
            @page-change="onPageChange"
            @page-size-change="onPageSizeChange"
            bordered
            hover
        >   

            <template #rateUser="{ row }">
                <div class="rate-user-wrap"> 
                    <div class="rate-user-name">{{ row.rateUserName }}</div>
                    <div class="rate-user-id">ID:{{ row.rateUserId }}</div>
                    <div class="rate-time">{{ row.rateTime }}</div>
                </div>
            </template>

            <!-- 评分 -->
            <template #rate="{ row }">
                <div class="rate-wrap"> 
                    <div class="rate">{{ row.rate }}</div>
                    <div class="rateDetail">
                        环境{{ row.envRate || '0.0' }} 设施{{ row.facilityRate || '0.0' }} 体验{{ row.experienceRate || '0.0' }}
                    </div>
                </div>
            </template>

            <!-- 评价营地 -->
            <template #rateCamp="{ row }">
                <div class="rate-camp-wrap"> 
                    <img class="rate-camp-image" :src="row.rateCampImage" alt=""  />
                    <div class="rate-camp-info">
                            <div class="rate-camp-name">{{ row.rateCampName }}</div>
                            <div class="rate-camp-id">ID:{{ row.rateCampId }}</div>
                    </div>
                </div>
            </template>

            <!-- 评价内容 -->
            <template #rateContent="{ row }">
                <div class="rate-content-wrap">
                    <div class="rate-content-text">{{ row.rateContentText }}</div>
                    <div class="rate-image-wrap">
                        <t-image
                            v-for="(image, index) in row.rateImage"
                            class="rate-image"
                            :key="index"
                            :src="image"
                            @click="openImageViewer(row, index)"
                        />
                    </div>
                </div>
            </template>

            <!-- 状态 -->
            <template #status="{ row }">
                {{ row.status === 1 ? '正常' : row.status === 2 ? '已隐藏' : row.status }}
            </template>

            <!-- 操作 -->
            <template #action="{ row }">
                <div class="table-action-button">
                    <t-link
                        class="status-action"
                        theme='primary'
                        hover="color"
                        @click="switchStatus(row)"
                    >
                        {{ row.status === 1 ? '隐藏' : '取消隐藏' }}
                    </t-link>

                    <t-link
                        class="delete-action"
                        v-if="row.status === 2"
                        theme="danger"
                        hover="color"
                        @click="deleteItem(row)"
                    >
                        删除
                    </t-link>
                </div>
            </template>
        </t-table>
    </div>
    <t-image-viewer
        v-if="showImageViewer"
        v-model:visible="showImageViewer"
        :images="currentRowImage"
        :defaultIndex="currentImageIndex"
        :show-indicators="true"
    /> 
</template>

<script setup lang="jsx">
    import { ref, onMounted } from 'vue';
    import { useRouter } from 'vue-router'; 
    import { MessagePlugin } from 'tdesign-vue-next';
    import rateAPI from '../../../api/rate-api';

    const router = useRouter();

    /**
     * 数据初始化
     */

    //评价数据初始化
    const rateData = ref([]);

    /**
     * 表格初始字段
     */
     const columns=ref([
        { colKey: 'rateUser', title: '评价用户',width: 160},
        { colKey: 'rate', title: '评分', width: 200,},
        { colKey: 'rateContent', title: '评价内容' },
        { colKey: 'rateCamp', title: '评价营地'},
        { colKey: 'status', title: '状态', width: 120},
        { colKey: 'action', title: '操作',width: 200,},
    ]);

    // 获取评价数据
    const getRateData = async () => {
        try {
            const response = await rateAPI.getRateList(pagination.value.current, pagination.value.pageSize);
            // 处理状态显示
            rateData.value = response.rateData;
            
            // 更新分页信息
            pagination.value.total = response.pagination.total;
            pagination.value.current = response.pagination.current;
            // 如果后端返回了pageSize，也可以更新
            if (response.pagination.pageSize) {
                pagination.value.pageSize = response.pagination.pageSize;
            }
        } catch (error) {
            console.error('获取评价数据失败:', error);
            MessagePlugin.error('获取评价数据失败，请重试');
        }
    };
    
    /**
     * 分页数据处理
     */
    const pagination = ref({
        total: 0,
        pageSize: 10,
        current: 1,
        pageSizeOptions: [10, 20, 50],
        showSizeChanger: true,
    });
    
    // 页码变化处理
    const onPageChange = (pageInfo) => {
        pagination.value.current = pageInfo.current;
        getRateData();
    };

    // 每页数量变化处理
    const onPageSizeChange = (pageSize) => {
        pagination.value.pageSize = pageSize;
        pagination.value.current = 1; // 切换每页数量时重置为第一页
        getRateData();
    };

    // 组件挂载时获取数据
    onMounted(() => {
        getRateData();
    });

    // 状态类型选项
    const statusType = ref([
        { label: '正常', value: '1' },
        { label: '已隐藏', value: '2' }
    ]);
  
    const switchStatus = async (row) => {
        try {
            const newStatus = row.status === '正常' ? '已隐藏' : '正常';
            await rateAPI.updateRateStatus(row.id, newStatus);
            row.status = newStatus;
            MessagePlugin.success('状态更新成功');
        } catch (error) {
            console.error('更新状态失败:', error);
            MessagePlugin.error('更新状态失败，请重试');
        }
    }

    const deleteItem = async (row) => {
        try {
            await rateAPI.deleteRate(row.id);
            // 从列表中移除该项
            rateData.value = rateData.value.filter(item => item.id !== row.id);
            MessagePlugin.success('删除成功');
        } catch (error) {
            console.error('删除失败:', error);
            MessagePlugin.error('删除失败，请重试');
        }
    }


    /**
     * 图片预览
     */
     const showImageViewer = ref(false); 
    const currentImageIndex = ref(0); 
    const currentRowImage = ref([]) 
    const openImageViewer = (row, index) => {
        currentRowImage.value = row.rateImage || [];
        currentImageIndex.value = index;
        showImageViewer.value = true; 
    }; 

</script>

<style scoped>
  @import "./camp-rate.css";
  @import "../../../components/style/style-content.css";
  @import "../../../components/style/style-table.css";
  @import "../../../components/style/style-filter.css";
</style>
  